import React, { Component } from "react";
import { Form, Input, PageHeader, Descriptions, Row, Col, Checkbox, InputNumber, Upload, message, Spin, Icon, Modal } from 'antd';
import NHFormItem from '../../common/NHFormItem';
import NHFetch from "../../../utils/NHFetch";
import NHSelect from "../../common/NHSelect";
import { createUuid } from "../../../utils/NHCore";
import Viewer from 'react-viewer';
import css from './index.css';
const Dragger = Upload.Dragger;
const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;

/**
 * 绿色通道编辑表单
 * @author admin
 * @date 2018-03-16 11:28:34
 * Version: 1.0
 */
class EditInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            previewImage: '',
            previewVisible: false,
            fileList: [],
            uploading: false,
            checkedOptions: [],
            defaultChecked: [],
            judgeImgList: ['.png', '.PNG', '.jpg', '.JPG', '.bpm', '.BPM', '.jpeg', '.JPEG'],   //可以导入的图片格式
            judgeFileList: ['.pdf', '.PDF', '.doc', '.DOC', '.zip', '.ZIP', '.txt', '.TXT', '.xls', '.XLS', '.rar', '.RAR'],  //可以导入的非图片格式
            checkGroup: [],//绿色通道办理原因
            showQtyy: 0,
            disableds: [true, true, true, true, true, true, true],
            requireds: [false, false, false, false, false, false, false],
            checkeds: [false, false, false, false, false, false, false],
            fjShow: false,
        }
    }

    componentWillMount() {
        NHFetch('/proData/selectDataList', 'get', 'sign=dmk_HNNY_YXXT_LSTD_BLYY').then(res => {
            /*if(res){
                let data = res.data;
                let checkedOptions = data.map(item=>{return {label:item.LABEL,value:item.VALUE}});
                this.setState({checkedOptions:checkedOptions});
            }*/
            if (res) {
                let col = [];
                res.data.map(item => {
                    col.push(
                        <Col span={6}>
                            <Checkbox value={item.VALUE} onChange={item.VALUE == 99 ? this.slowReason : ''}>
                                {item.LABEL}
                            </Checkbox>
                        </Col>
                    );
                });
                let html = <Row>{col}</Row>
                this.setState({ checkGroup: html });
            }
        });
        let initFormData = this.props.initFormData;
        if (initFormData.PKID) {//查询办理原因列表
            NHFetch(`/swbl/lstd/lstdblyy/${initFormData.PKID}/getBlyyList`, 'get').then(res => {
                if (res) {
                    this.setState({ defaultChecked: res.data });
                }
            });


        }
    }

    componentDidMount() {
        let initFormData = this.props.initFormData;
        if (initFormData.PKID) {
            this.loadfileList(initFormData.PKID);
        }
        if (initFormData.BLYY) {
            if (initFormData.BLYY.includes("其他")) {
                this.setState({ showQtyy: 1 });
            }
        }

        let disableds = [...this.state.disableds];
        let requireds = [...this.state.requireds];
        let checkeds = [...this.state.checkeds];
        let fileds = ['HJXFZSFJE', 'SHBTJE', 'SHYPJE', 'LFBZJE', 'QTBZJE', 'SYDDKJE',/* 'GXDKJE' */];
        fileds.map((item, index) => {
            if (initFormData[item]) {
                disableds = disableds.map((item, idx) => idx === index ? false : item);
                requireds = requireds.map((item, idx) => idx === index ? true : item);
                checkeds = checkeds.map((item, idx) => idx === index ? true : item);
            }
        });
        this.setState({
            disableds: disableds,
            requireds: requireds,
            checkeds: checkeds,
        })
    }

    loadfileList = (pkid) => {
        NHFetch(`/swbl/lstd/${pkid}/getFjList`, 'get').then(res => {
            if (res) {
                let fileList = [];
                if (res.data && res.data.length > 0) {
                    res.data.map((elem, index) => {
                        //格式化对于附件取值
                        let file = {
                            uid: elem.fjid,
                            name: elem.fjmc,
                            response: {
                                data: {
                                    ssbh: elem.fjid,
                                    fjmc: elem.fjmc,
                                }
                            },
                            status: 'done'
                        }
                        fileList.push(file);
                    })
                }
                this.setState({
                    fileList: fileList,
                    fj: res.data,
                    fjShow: true,
                });
                this.props.form.setFieldsValue({ fj: { fileList: this.state.fileList } });
            }
        });
    }


    beforeUpload = (file) => {
        if (
            !(this.setJudge(file.name, this.state.judgeImgList) ||
                this.setJudge(file.name, this.state.judgeFileList))
        ) {
            message.error('不能上传该格式文件');
            return false;
        } else {
            return true;
        }
    }

    // 关闭图片弹窗
    handleCancel = () => this.setState({ previewVisible: false });

    remove = (ssbh) => {
        let url = `api/docrepo/attachment/sourceId/delete?souerceId=${ssbh}`;
        NHFetch(url, "POST").then(res => {
            if (res.data && res.data > 0) {
                message.success('已删除材料.');
            }
        });
    }

    handleChange = ({ fileList }) => {
        let count = 0;
        fileList.map((elem) => {
            if (elem && elem['status'] && elem['status'] === 'uploading') {
                this.setState({ uploading: true });
                return;
            } else if (elem && elem['status']) {
                count++;
            }
        })
        if (count > 0) {
            this.setState({ uploading: false });
        }
    }

    //判断文件类型是否正常  name：文件名称  map：类型范围数组  true正常
    setJudge = (name, map) => {
        let flag = false;
        map.map(item => {
            if (name.indexOf(item) !== -1) {
                flag = true;
            }
        })
        return flag;
    }

    // 转化base64
    getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    };

    // 勾选其他操作
    slowReason = (e) => {
        let check = e.target.checked;
        if (check) {
            this.setState({ showQtyy: 1 });
        } else {
            this.setState({ showQtyy: 0 });
        }

    }

    // 控制输入框的disabled, required
    onChangeControlDisabled = (e) => {
        const { setFieldsValue } = this.props.form
        let { checked, id } = e.target;
        let index = e.target.index;
        const disableds = [...this.state.disableds].map((item, idx) => idx === index ? !checked : item);
        const requireds = [...this.state.requireds].map((item, idx) => idx === index ? checked : item);
        //由系统维护的金额数据
        debugger;
        const ids = ["shbt", "shyp", "lfbz"];
        if (ids.find(item => item === id)) {
            if (checked) {
                this.querybtje(id, setFieldsValue);
            } else {
                setFieldsValue({ [id + "je"]: undefined })
            }
        }
        if (index)
            if (index === 5 && checked) {
                disableds[6] = true;
                requireds[6] = false;
            }
        if (index === 6 && checked) {
            disableds[5] = true;
            requireds[5] = false
            this.props.form.setFieldsValue({
                'syddk': false,
                'syddkje': undefined,
                'dkyh': ''
            })
        }
        this.setState({
            disableds: disableds,
            requireds: requireds,
        })
    }

    //获取系统管理维护好的补贴金额
    querybtje = (formId, callback) => {
        const prefix = "YXXT_LSTD_"
        NHFetch("api/zhxg-yxwz/lstd/getConstantByCode", "GET", { dmbz: prefix + formId.toUpperCase() })
            .then(res => {
                if (!res.data.data.csz) {
                    message.info("请联系管理员配置预设金额。");
                    return;
                }
                callback({ [formId + "je"]: parseFloat(res.data.data.csz) })
            })
    }

    // (这个地方包含处理审核和新增的图片预览逻辑。)点击文件链接或预览图标时的回调
    handlePreview = (fj, fjid) => {
        let isImage = true;
        const name = fj.name || fj.fjmc;
        fjid = fjid || fj.response.data.ssbh
        if (
            !this.setJudge(name, this.state.judgeImgList)
        ) {
            isImage = false;
        }

        if (isImage) {
            this.showPreview(`anonymity/docrepo/download/file?attachmentId=${fjid}`);
        } else {
            window.open(`anonymity/docrepo/download/file?attachmentId=${fjid}`);
        }
    };
    showPreview = (url) => {
        this.setState({
            previewImage: url,
            previewVisible: true
        });
    }

    render() {
        const { form, initFormData, editType } = this.props;
        //console.log("editType:" + editType);
        let formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 20 },
        };
        let formItemLayoutJE = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
        };
        const props = {
            name: 'file',
            action: 'api/docrepo/upload',
            data: { uuid: createUuid(), type: '1' },
            onRemove: file => {
                this.setState(({ fileList }) => {
                    const index = fileList.indexOf(file);
                    const newFileList = fileList.slice();
                    newFileList.splice(index, 1);
                    this.props.form.setFieldsValue({ fj: { fileList: newFileList } });
                    return {
                        fileList: newFileList
                    };
                }, () => {
                    if (file.response && file.response.data && file.response.data.ssbh) {
                        this.remove(file.response.data.ssbh);
                    }
                });
            },
            beforeUpload: file => {
                if (!this.beforeUpload(file)) {
                    return false;
                }
                this.setState(({ fileList }) => ({
                    fileList: [...fileList, file]
                }));
                return true;
            },
            onChange: file => {
                this.handleChange(file)
            },
            onPreview: this.handlePreview,
            fileList: this.state.fileList,
        };
        const checkedOptions = this.state.checkedOptions;
        return (
            <div>
                <div style={{ display: 'none' }}>
                    <NHFormItem id={"pkid"}
                        form={this.props.form}
                        initialValue={initFormData.PKID}>
                        <Input />
                    </NHFormItem>
                    <NHFormItem id={"xsid"} required={true}
                        form={this.props.form}
                        initialValue={initFormData.XSID}>
                        <Input />
                    </NHFormItem>
                    <NHFormItem id={"nd"} required={true}
                        form={this.props.form}
                        initialValue={initFormData.ND}>
                        <Input />
                    </NHFormItem>
                </div>
                <div className={css.PageHeaderdiv}>
                    <PageHeader ghost={false} title="学生信息">
                        <Descriptions size="small" column={3} style={{ marginLeft: '80px' }}>
                            <Descriptions.Item label="姓名(学号)">{initFormData.XH ? `${initFormData.XM}(${initFormData.XH})` : ''}</Descriptions.Item>
                            <Descriptions.Item label="性别">{initFormData.XB}</Descriptions.Item>
                            <Descriptions.Item label="学院">{initFormData.BMMC}</Descriptions.Item>
                            <Descriptions.Item label="专业">{initFormData.ZYMC}</Descriptions.Item>
                            <Descriptions.Item label="班级">{initFormData.BJMC}</Descriptions.Item>
                            <Descriptions.Item label="年度">{initFormData.ND}</Descriptions.Item>
                        </Descriptions>
                    </PageHeader>
                </div>
                <div className={css.PageHeaderdiv}>
                    <PageHeader ghost={false} title="办理原因">
                        <div style={{ marginLeft: '80px' }}>
                            <NHFormItem id={"blyy"} required={true}
                                form={this.props.form} formItemLayout={formItemLayout}
                                initialValue={this.state.defaultChecked}>
                                <CheckboxGroup>
                                    {this.state.checkGroup}
                                </CheckboxGroup>
                            </NHFormItem>
                            {
                                this.state.showQtyy == 1 &&
                                <NHFormItem id={'qtblyy'} initialValue={initFormData.QTBLYY} form={this.props.form}
                                    formItemLayout={formItemLayout} required={true}
                                    label="其他原因">
                                    <TextArea style={{ width: '60%' }} maxLength={50} placeholder="填写其他原因" />
                                </NHFormItem>
                            }
                        </div>
                    </PageHeader>
                </div>
                <div className={css.PageHeaderdiv}>
                    <PageHeader ghost={false} title="申请类型">
                        <div style={{ marginLeft: '80px' }}>
                            <Row>
                                <Col span={4}>
                                    <NHFormItem id={'hjxfzsf'} initialValue={this.state.checkeds[0]} form={form} formItemLayout={formItemLayoutJE}>
                                        <Checkbox index={0} onChange={this.onChangeControlDisabled} defaultChecked={initFormData.HJXFZSFJE ? true : false}>
                                            缓交学费住宿费
                                        </Checkbox>
                                    </NHFormItem>
                                </Col>
                                <Col span={8}>
                                    <NHFormItem id={'hjxfzsfje'} key={'hjxfzsfje'} initialValue={initFormData.HJXFZSFJE} form={form} formItemLayout={formItemLayoutJE} label="缓交金额(元)"
                                        required={this.state.requireds[0]}
                                    >
                                        <InputNumber disabled={this.state.disableds[0]} style={{ width: '50%' }} />
                                    </NHFormItem>
                                </Col>
                                <Col span={4}>
                                    <NHFormItem id={'shbt'} initialValue={this.state.checkeds[1]} form={form} formItemLayout={formItemLayoutJE}>
                                        <Checkbox index={1} onChange={this.onChangeControlDisabled} defaultChecked={initFormData.SHBTJE ? true : false}>
                                            生活补贴
                                        </Checkbox>
                                    </NHFormItem>
                                </Col>
                                <Col span={8}>
                                    <NHFormItem id={'shbtje'} initialValue={initFormData.SHBTJE} form={form} formItemLayout={formItemLayoutJE} label="补贴金额(元)"
                                        required={this.state.requireds[1]}
                                    >
                                        <InputNumber disabled style={{ width: '50%' }} />
                                    </NHFormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={4}>
                                    <NHFormItem id={'shyp'} initialValue={this.state.checkeds[2]} form={form} formItemLayout={formItemLayoutJE}>
                                        <Checkbox index={2} onChange={this.onChangeControlDisabled} defaultChecked={initFormData.SHYPJE ? true : false}>
                                            生活用品
                                        </Checkbox>
                                    </NHFormItem>
                                </Col>
                                <Col span={8}>
                                    <NHFormItem id={'shypje'} initialValue={initFormData.SHYPJE} form={form} formItemLayout={formItemLayoutJE} label="补贴金额(元)"
                                        required={this.state.requireds[2]}
                                    >
                                        <InputNumber disabled style={{ width: '50%' }} />
                                    </NHFormItem>
                                </Col>
                                <Col span={4}>
                                    <NHFormItem id={'lfbz'} initialValue={this.state.checkeds[3]} form={form} formItemLayout={formItemLayoutJE}>
                                        <Checkbox index={3} onChange={this.onChangeControlDisabled} defaultChecked={initFormData.LFBZJE ? true : false}>
                                            路费补助
                                        </Checkbox>
                                    </NHFormItem>
                                </Col>
                                <Col span={8} className="p-col">
                                    <NHFormItem id={'lfbzje'} initialValue={initFormData.LFBZJE} form={form} formItemLayout={formItemLayoutJE} label="补贴金额(元)"
                                        required={this.state.requireds[3]}
                                    >
                                        <InputNumber disabled style={{ width: '50%' }} />
                                    </NHFormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={4}>
                                    <NHFormItem id={'qtbz'} initialValue={this.state.checkeds[4]} form={form} formItemLayout={formItemLayoutJE}>
                                        <Checkbox index={4} onChange={this.onChangeControlDisabled} defaultChecked={initFormData.QTBZJE ? true : false}>
                                            其他补助
                                        </Checkbox>
                                    </NHFormItem>
                                </Col>
                                <Col span={8} className="p-col">
                                    <NHFormItem id={'qtbzje'} initialValue={initFormData.QTBZJE} form={form} formItemLayout={formItemLayoutJE} label="补贴金额(元)"
                                        required={this.state.requireds[4]}
                                    >
                                        <InputNumber disabled={this.state.disableds[4]} style={{ width: '50%' }} />
                                    </NHFormItem>
                                </Col>
                            </Row>
                        </div>
                    </PageHeader>
                </div>

                <div className={css.PageHeaderdiv}>
                    <PageHeader ghost={false} title="申请助学贷款类型：">
                        <Row type="flex" justify="center">
                            <Col span={4}>
                                <NHFormItem id={'syddk'} initialValue={this.state.checkeds[5]} valuePropName='checked' form={form} formItemLayout={formItemLayoutJE}>
                                    <Checkbox index={5} onChange={this.onChangeControlDisabled} defaultChecked={initFormData.SYDDKJE ? true : false}>
                                        生源地信用助学贷款
                                    </Checkbox>
                                </NHFormItem>
                            </Col>
                            <Col span={8}>
                                <NHFormItem id={'syddkje'} initialValue={initFormData.SYDDKJE} form={form} formItemLayout={formItemLayoutJE} label="贷款金额(元)"
                                    required={this.state.requireds[5]}
                                >
                                    <InputNumber disabled={this.state.disableds[5]} style={{ width: '50%' }} />
                                </NHFormItem>
                            </Col>
                        </Row>
                        <Row type="flex" justify="center">
                            <Col span={8}>
                                <NHFormItem id={'dkyh'} initialValue={initFormData.DKYH} form={form} formItemLayout={formItemLayoutJE} label="贷款银行"
                                    required={this.state.requireds[5]}>
                                    <NHSelect sign={"dmk_yxwz_dkyh"} onChange={(v) => { }} disabled={this.state.disableds[5]} style={{ width: "50%" }} />
                                </NHFormItem>
                            </Col>
                        </Row>
                    </PageHeader>
                </div>

                {
                    (initFormData.SJLY == '1' || editType === "add" || editType === "update") &&
                    <div className={css.PageHeaderdiv}>
                        <PageHeader ghost={false} title="证明材料">
                            <NHFormItem id={"fj"} hasFeedback={true} form={form}
                                formItemLayout={{ labelCol: { span: 4 }, wrapperCol: { span: 8 } }}>
                                <Dragger {...props} style={{ marginLeft: '80px' }}>
                                    <p className="ant-upload-drag-icon">
                                        <Icon type="inbox" />
                                    </p>
                                    <Spin spinning={this.state.uploading} />
                                    <p className="ant-upload-text font-14">
                                        点击此处或拖拽文件到此
                                    </p>
                                </Dragger>
                            </NHFormItem>
                        </PageHeader>
                        <PageHeader ghost={false} title="申请理由">
                            <NHFormItem id={"sqsm"} required={false}
                                initialValue={initFormData.SQSM}
                                form={this.props.form} formItemLayout={formItemLayout}>
                                <TextArea maxLength={80} placeholder="请填写申请理由" style={{ marginLeft: '80px', width: '600px' }} />
                            </NHFormItem>
                        </PageHeader>
                    </div>
                }
                {
                    initFormData.SJLY == '2' &&
                    <div className={css.PageHeaderdiv}>
                        <div style={{ display: 'none' }}>
                            <NHFormItem id={'fj'} required={false} form={this.props.form}>
                                <Input />
                            </NHFormItem>
                        </div>
                        <PageHeader ghost={false} title="证明材料">
                            {this.state.fjShow &&
                                <Row gutter={24}>
                                    <Col span={20}>
                                        {this.state.fj.map((elem, index) => {
                                            return (
                                                <div style={{ marginBottom: '20px', marginLeft: '80px' }}>
                                                    <a onClick={() => {
                                                        this.handlePreview(elem, elem['fjid']);
                                                    }}>{elem['fjmc']}</a>
                                                </div>
                                            )
                                        })}
                                    </Col>
                                </Row>
                            }
                        </PageHeader>
                        <PageHeader ghost={false} title="申请理由">
                            <NHFormItem form={this.props.form} formItemLayout={formItemLayout}>
                                <label style={{ marginLeft: '80px' }}>{initFormData.SQSM}</label>
                            </NHFormItem>
                        </PageHeader>
                    </div>
                }
                <Viewer
                    visible={this.state.previewVisible}
                    onClose={this.handleCancel}
                    images={[{ src: this.state.previewImage, alt: '' }]}
                />
            </div >
        );
    }
}

const EditForm = Form.create()(EditInitForm);

export default EditForm;


// WEBPACK FOOTER //
// ./components/swbl/lstd/EditForm.js